if (!customElements.get('mm-variant-selects')) {

  class MMVariantSelects extends HTMLElement {
    constructor() {
      super();
      this.addEventListener('change', this.onVariantChange);
      this.other = Array.from(document.querySelectorAll('mm-variant-selects')).filter((selector) => {
        return selector != this;
      });

      this.productWrapper = this.closest('.mm-product-card');
      this.productSlider = this.productWrapper.querySelector('.product-card__image-wrapper');
    }

    connectedCallback() {
      this.updateOptions();
      this.updateMasterId();
      this.setDisabled();
    }

    onVariantChange() {
      this.updateOptions();
      this.updateMasterId();
      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();
      this.setDisabled();

      if (!this.currentVariant) {
        this.toggleAddButton(true, '', true);
        this.setUnavailable();
      } else {
        this.updateMedia();
        this.updateVariantInput();
        this.renderProductInfo();
      }

      const isShowSizeChart = this.getAttribute('data-size-chart') === 'true' ? true : false;
      if(isShowSizeChart) {
        this.renderProductInfoForCollectionPage();
        this.updatePopupSizeCheck();
      }
    }

    updatePopupSizeCheck() {
      const productCard = this.closest('.mm-product-card');
      if(!productCard) return;

      const productId = productCard.getAttribute('data-product-id');
      const popupModal = document.querySelector(`#PopupModal-SizingCheck-${productId}`);
      if(!popupModal) return;

      const tableToShow = popupModal.querySelectorAll('tbody');
      tableToShow.forEach((table) => {
        const variantId = Number(table.getAttribute('data-variant-id'));
        if(variantId === this.currentVariant.id) {
          table.style.display = 'contents';
        } else {
          table.style.display = 'none';
        }
      });
    }

    renderProductInfoForCollectionPage() {
      const productCard = this.closest('.mm-product-card');
      if(!productCard) return;

      const dynamicContentDivs = Array.from(productCard.querySelectorAll('.product-card__dynamic-content'));
      dynamicContentDivs.forEach((div) => {
        const variantId = Number(div.getAttribute('data-variant-id'));
        if(variantId === this.currentVariant.id) {
          div.classList.add('active');
        } else {
          div.classList.remove('active');
        }
      });
    }

    updateOptions() {
      this.fieldsets = Array.from(this.querySelectorAll('.fieldset-variant'));
      this.options = [];
      this.fieldsets.forEach((fieldset) => {
        const checkedInput = fieldset.querySelector('input:checked');
        if (fieldset.querySelectorAll('input').length && checkedInput) {
          this.options.push(checkedInput.value);
        }
      });
    }

    updateMasterId() {
      this.currentVariant = this.getVariantData().find((variant) => {
        return !variant.options.map((option, index) => {
          return this.options[index] === option;
        }).includes(false);
      });
    }

    updateMedia() {
      if (!this.currentVariant) return;
      if (!this.currentVariant.featured_media) return;

      const variantMedia = this.currentVariant.featured_media?.preview_image?.src;
      if (!variantMedia) return;

      const imageToReplace = this.closest(".mm-product-card").querySelector('.product__card-image');
      if (!imageToReplace) return;

      imageToReplace.setAttribute('data-src', variantMedia);
      imageToReplace.setAttribute('srcset', variantMedia);
    }

    updateVariantInput() {
      const productForm = document.querySelector(`#product-form-${this.dataset.section}${this.dataset.parent}`);
      if(!productForm) return;

      const input = productForm.querySelector('input[name="id"]');
      input.value = this.currentVariant.id;
      input.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    }

    removeErrorMessage() {
      const section = this.closest('.mm-product-card');
      if (!section) return;

      const productForm = section.querySelector('.mm-product-form');
      if (productForm) productForm.handleErrorMessage();
    }

    getSectionsToRender() {
      return [`price-${this.dataset.section}${this.dataset.parent}`, `variant-metafield-size-${this.dataset.section}${this.dataset.parent}`];
    }

    renderProductInfo() {
      let sections = this.getSectionsToRender();

      fetch(`${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html');
          const cardProduct = html.getElementById(`product-card-${this.dataset.section}${this.dataset.parent}`);

          sections.forEach((id) => {
            const destination = document.getElementById(id);
            const source = cardProduct?.querySelector(`#${id}`);

            if (source && destination) destination.innerHTML = source.innerHTML;
          });
          this.toggleAddButton(!this.currentVariant.available, window.theme.variantStrings.soldOut);
        });
    }

    toggleAddButton(disable = true, text = false, modifyClass = true) {
      const productForm = document.getElementById(`product-form-${this.dataset.section}${this.dataset.parent}`);
      if (!productForm) return;

      const submitButton = productForm.querySelector('.js-addToCart');
      if (!submitButton) return;

      const submitButtonText = submitButton.querySelector('.js-addToCart-text');
      if (!submitButtonText) return;

      if (disable) {
        submitButton.setAttribute('disabled', 'disabled');
        if (text) submitButtonText.textContent = text;
      } else {
        submitButton.removeAttribute('disabled');
        submitButton.classList.remove('loading');
        submitButtonText.textContent = window.theme.variantStrings.addToCart;
      }

      if (!modifyClass) return;
    }

    setUnavailable() {
      const submitButton = document.querySelector('.js-addToCart');

      const submitButtonText = submitButton.querySelector('.jsAddToCart-text');
      if (!submitButton) return;
      submitButtonText.textContent = window.theme.variantStrings.unavailable;
      submitButton.classList.add('sold-out');
    }

    setDisabled() {
      if(!this.currentVariant) return;
      const variant_data = this.getVariantData();

      if (variant_data) {
        const selected_options = this.currentVariant.options.map((value, index) => {
          return {
            value,
            index: `option${index + 1}`
          };
        });

        const available_options = this.createAvailableOptionsTree(variant_data, selected_options);

        this.fieldsets.forEach((fieldset, i) => {
          const fieldset_options = Object.values(available_options)[i];
          if(fieldset_options){
            if (fieldset.querySelectorAll('input').length) {
              fieldset.querySelectorAll('input').forEach((input, input_i) => {
                input.classList.toggle('is-disabled', fieldset_options[input_i].isUnavailable);
              });
            }
          }
        });

      }
      return true;
    }

    createAvailableOptionsTree(variant_data, selected_options) {
      // Reduce variant array into option availability tree
      return variant_data.reduce((options, variant) => {

        // Check each option group (e.g. option1, option2, option3) of the variant
        Object.keys(options).forEach(index => {

          if (variant[index] === null) return;

          let entry = options[index].find(option => option.value === variant[index]);

          if (typeof entry === 'undefined') {
            // If option has yet to be added to the options tree, add it
            entry = {
              value: variant[index],
              isUnavailable: true
            };
            options[index].push(entry);
          }

          // Check how many selected option values match a variant
          const countVariantOptionsThatMatchCurrent = selected_options.reduce((count, {
            value,
            index
          }) => {
            return variant[index] === value ? count + 1 : count;
          }, 0);

          // Only enable an option if an available variant matches all but one current selected value
          if (countVariantOptionsThatMatchCurrent >= selected_options.length - 1) {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }

          // Make sure if a variant is unavailable, disable currently selected option
          if ((!this.currentVariant || !this.currentVariant.available) && selected_options.find((option) => option.value === entry.value && index === option.index)) {
            entry.isUnavailable = true;
          }

          // First option is always enabled
          if (index === 'option1') {
            entry.isUnavailable = entry.isUnavailable && variant.available ? false : entry.isUnavailable;
          }
        });

        return options;
      }, {
        option1: [],
        option2: [],
        option3: []
      });
    }

    getVariantData() {
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      return this.variantData;
    }
  }

  customElements.define('mm-variant-selects', MMVariantSelects);
}